import { render, staticRenderFns } from "./FiscalFixedAssetCategory.vue?vue&type=template&id=2275692e"
import script from "./FiscalFixedAssetCategory.vue?vue&type=script&lang=js"
export * from "./FiscalFixedAssetCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports